export function getWellnessTileId(target = {}) {
  return target?.tileId || target?.value || target?.id || ''
}

export function getWellnessTilePolicyId(target = {}) {
  return (
    target?.policyId ||
    target?.tilePolicyId ||
    target?.policy?.id ||
    target?.policy?.value ||
    target?.tilePolicy?.id ||
    target?.tilePolicy?.value ||
    ''
  )
}

export function getWellnessTileLabel(target = {}, fallbackTileId = '') {
  return target?.label || target?.title || target?.tileTitle || fallbackTileId
}
